import {Mapper} from '@s-ui/domain'

export default class SearchItemJsonToSearchItemValueObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Function} toQueryParams
   * @param {Function} searchItemValueObjectFactory
   * @param {Function} getUrlService
   */
  constructor({toQueryParams, searchItemValueObjectFactory, getUrlService}) {
    super({toQueryParams, searchItemValueObjectFactory, getUrlService})
    this._toQueryParams = toQueryParams
    this._searchItemValueObjectFactory = searchItemValueObjectFactory
    this._getUrlService = getUrlService
  }

  map = async ({listingSectionId, pageName, params, query, title}) => {
    const urlValueObject = await this._getUrlService.execute({
      listingSectionId,
      pageName,
      params,
      query
    })
    const {url} = urlValueObject.toJSON()

    return this._searchItemValueObjectFactory({
      title,
      url
    })
  }
}
